import React from 'react';

/** Spinner de carga a pantalla completa. */
export const Spinner: React.FC = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40">
    <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/30 border-t-white" />
  </div>
);
